/**
 * <s-sticky-atc>: mobile sticky add-to-cart bar on the product page.
 * Shows (data-visible, not inert) once the main buy box ([data-sticky-atc-target]) has scrolled
 * fully above the viewport, and hides again when it comes back. The bar's own button submits the
 * main product form through its form attribute, so add-to-cart behaviour stays in <s-product-form>.
 */
class SStickyAtc extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = document.querySelector('[data-sticky-atc-target]');
    this.#setVisible(false);
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
